__turbopack_context__.v({
  "tooltip": "dateList-module-scss-module__ypprcW__tooltip",
});
